import { useTranslation } from "react-i18next";
import { useGetFeastDaysQuery } from "./api/feastDaysApiSlice";

const NextFeastDay = () => {

    const [t, i18n] = useTranslation(["global", "absenceReport"]);

    // API
    const {
        data: dates,
        isSuccess: isDatesSuccess,
        isError: isDatesError,
        error: datesError,
    } = useGetFeastDaysQuery({ year: new Date().getFullYear(), countryCode: "IT" });

    // Funzione per controllare se una data è nel passato
    const isPast = (eventDate) => {
        const today = new Date();
        const event = new Date(eventDate);

        // Confrontiamo solo le date (non l'ora)
        return (
            today.getFullYear() > event.getFullYear() ||
            (today.getFullYear() === event.getFullYear() &&
                today.getMonth() > event.getMonth()) ||
            (today.getFullYear() === event.getFullYear() &&
                today.getMonth() === event.getMonth() &&
                today.getDate() > event.getDate())
        );
    };

    // Funzione per formattare la data
    const formatDate = (date) => {
        if (date) return new Date(date).toLocaleDateString();
        return "Invalid date";
    };

    let content;

    if (isDatesError) {
        content = <span>Error: {datesError?.message || "Failed to load data."}</span>;
    } else if (!isDatesSuccess) {
        content = <span>Loading...</span>;
    } else {
        // Troviamo la prossima festività
        const nextFeastDay = dates.find((date) => !isPast(date.date));
        if (nextFeastDay) {
            content = (
                <>
                    <h2 className="text-muted"><i className="fa-solid fa-champagne-glasses"></i></h2>
                    <b>{nextFeastDay.localName}</b> <br />
                    {formatDate(nextFeastDay.date)}

                </>
            );
        } else {
            content = <span>{t("absenceReport:no_data.no_next_feast_day")}</span>;
        }
    }

    return <div className="feastDays">{content}</div>;
};

export default NextFeastDay;
